var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{on:{"sheet":_vm.toggleSheet,"snack":_vm.toggleSnack,"loading":_vm.toggleLoading,"sessionSync":_vm.sessionSync}})
}
var staticRenderFns = []

export { render, staticRenderFns }